export default __webpack_public_path__ + "f81d2454f942abe3150b45526841b6ec.glb";